<template>
  <div id="BookSuite" class="outer-container">
    <div id="BookSuite-selector"></div>
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  alpha,
  numeric,
} from "vuelidate/lib/validators";
export default {
  name: "BookSuiteForm",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      interest: "",
      submitStatus: null,
      iframeSrc: "https://rangers.fanportal-mlb.com/20game/form/form.html",
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        console.log(this.submitStatus);
      } else {
        setInterval(this.timestamp(), 500);
        this.submitStatus = "OK";
      }
    },
    timestamp() {
      var response = document.getElementById("g-recaptcha-response");
      if (response == null || response.value.trim() == "") {
        var elems = JSON.parse(
          document.getElementsByName("captcha_settings")[0].value
        );
        elems["ts"] = JSON.stringify(new Date().getTime());
        document.getElementsByName("captcha_settings")[0].value =
          JSON.stringify(elems);
      }
    },
  },
  validations: {
    firstName: {
      required,
      alpha,
    },
    lastName: {
      required,
      alpha,
    },
    email: {
      required,
      email,
    },
    phone: {
      required,
      minLength: minLength(10),
      numeric,
    },
    interest: {
      required,
    },
  },
};
</script>

<style lang="scss" scoped>
.outer-container {
  position: relative;
  height: 600px;
  // @media only screen and (max-width: $lg) {
  //   height: 1449px;
  // }
  @media only screen and (max-width: $md) {
    height: 850px;
  }
  // @media only screen and (max-width: $sm) {
  //   height: 2157px;
  // }
  iframe {
    position: relative;
    background: #c02133; /* fallback colour. Make sure this is just one solid colour. */
    // background: url("~@/assets/images/backgrounds/pick-your-plan-bg.jpg") rgba(#003278, 0.7);
    background: url("~@/assets/images/backgrounds/light-texture-bg.jpg");
    background-size: cover;
    // background-repeat: no-repeat;
    // background-blend-mode: multiply;
    width: 100%;
    height: 100%;
  }
}
</style>
